import isNil from 'lodash/isNil';
import negate from 'lodash/negate';
import { inferParserType, Values } from 'nuqs';
import { FromArray } from '../../utils/type-helpers';
import { BuildingFiltersKeys } from './BuildingFilters';
import { BUILDING_FILTERS_SEARCH_PARAMS } from './search-params';

export const calculateFilterCount = (
  filters: inferParserType<typeof BUILDING_FILTERS_SEARCH_PARAMS>,
  excludeSectionFilters = true,
): number => {
  const excludeKeys: BuildingFiltersKeys[] = [];

  if (excludeSectionFilters) {
    excludeKeys.push(
      BuildingFiltersKeys.buildingIds,
      BuildingFiltersKeys.economicUnitIds,
      BuildingFiltersKeys.portfolioIds,
    );
  }

  return Object.entries(filters)
    .filter(([key]) => !excludeKeys.includes(key as BuildingFiltersKeys))
    .reduce((acc, [, filter]) => {
      if (isNil(filter)) return acc;
      if (Array.isArray(filter)) {
        return acc + filter.filter(negate(isNil)).length;
      }
      return acc + 1;
    }, 0);
};

export const toggleFilter = <
  TFilter extends Extract<
    keyof typeof BUILDING_FILTERS_SEARCH_PARAMS,
    'euTaxonomyCompliance' | 'taxBrackets' | 'efficiencyClasses' | 'energySourceTypes'
  >,
>(
  filters: Values<typeof BUILDING_FILTERS_SEARCH_PARAMS>,
  filter: TFilter,
  value: FromArray<NonNullable<inferParserType<typeof BUILDING_FILTERS_SEARCH_PARAMS>[TFilter]>>,
) => {
  const prevFilter = filters[filter];

  const hasFilter = prevFilter !== null && prevFilter.length > 0 && prevFilter.some((it) => it === value);

  if (hasFilter) {
    const newFilter = prevFilter?.filter((it) => it !== value) ?? [];
    return {
      ...filters,
      [filter]: newFilter.length > 0 ? newFilter : null,
    };
  }

  return {
    ...filters,
    [filter]: [...(prevFilter ?? []), value],
  };
};
